/**
 * 구매 아이템별 제공되는 할인혜택 유형
 */
export const ItemDiscountCategory = {
    /** 즉시할인 */
    IMMEDIATE: 'IMMEDIATE',
    /** 상품할인 */
    PRODUCT: 'PRODUCT',
    /** 중복할인 */
    DUPLICATE: 'DUPLICATE',
} as const

/**
 * 정책적으로 조건 만족시 무조건 제공되는 할인혜택 유형
 */
export const PolicyDiscountCategory = {
    /** 중복 구배 할인 */
    MULTI_PURCHASE: 'MULTI_PURCHASE',
} as const
/**
 * 판매자(C2의 스토어, C1, 온라인결제의 가맹점)별 제공되는 할인혜택 유형
 */
export const MerchantDiscountCategory = {
    /** 주문형 스토어 또는 디컨 판매처, 온라인결제(인증형,결제형) 가맹점 별 할인 */
    MERCHANT: 'MERCHANT',
} as const

/**
 * 배송그룹별 제공가능한 할인혜택 유형
 */
export const DeliveryDiscountCategory = {
    /** 배송할인 */
    DELIVERY: 'DELIVERY',
} as const
/**
 * 구독그룹별 제공가능한 할인 혜택 유형
 */
export const SubscriptionDiscountCategory = {
    /** 정기구독 할인 */
    SUBSCRIPTION: 'SUBSCRIPTION',
} as const
/**
 * 판매자(NPay 이용사) > 상품할인(C1만), 상품중복할인, 스토어할인, 배송비할인
 * 관리자(NPay) > 상품할인, 상품중복할인, 배송비할인
 */
export const DiscountCoupon = {
    /** 판매자 즉시할인 (상품할인 (판매자)) */
    SELLER_IMMEDIATE_DISCOUNT: 'SELLER_IMMEDIATE_DISCOUNT',
    /** 판매자 상품할인 (상품할인 (판매자)) */
    SELLER_PRODUCT_DISCOUNT: 'SELLER_PRODUCT_DISCOUNT',
    /**
     * @deprecated 관리자 즉시할인 (네이버 추가할인 (네이버 페이))
     * 사용하지 않아 fade-out 예정
     **/
    MANAGER_IMMEDIATE_DISCOUNT: 'MANAGER_IMMEDIATE_DISCOUNT',
    /** 관리자 상품할인 (네이버 추가할인 (네이버 페이)) */
    MANAGER_PRODUCT_DISCOUNT: 'MANAGER_PRODUCT_DISCOUNT',
    /** 단골 할인 (스토어 찜 할인) */
    SUBSCRIBER_DISCOUNT: 'SUBSCRIBER_DISCOUNT',
    /** 중복할인 (상품 추가할인) */
    DUPLICATE_PRODUCT_DISCOUNT: 'DUPLICATE_PRODUCT_DISCOUNT',
    /** 복수구매할인 (쿠폰이 아닌 할인 policy로 관리) */
    MULTI_PURCHASE_DISCOUNT: 'MULTI_PURCHASE_DISCOUNT',
    /** 스토어 할인 */
    STORE_DISCOUNT: 'STORE_DISCOUNT',
    /** 주문 할인 */
    ORDER_DISCOUNT: 'ORDER_DISCOUNT',
    /** 배송비 할인 */
    DELIVERY_DISCOUNT: 'DELIVERY_DISCOUNT',
    /** 판매자 상품 할인 (C1) */
    MERCHANT_PRODUCT_DISCOUNT: 'MERCHANT_PRODUCT_DISCOUNT',
    /** 정기구독 할인 */
    SUBSCRIPTION_DISCOUNT: 'SUBSCRIPTION_DISCOUNT',
} as const

export type DiscountCouponType = Constant<typeof DiscountCoupon>

/** 할인률 정책 */
export const DiscountPolicy = {
    RATIO: 'RATIO', // 정률
    AMOUNT: 'AMOUNT', // 정액
    // TODO: API 응답 모델에 없는 타입이나 View 구성에 필요할 수 있음. 확인 요망
    /** @deprecated see) https://oss.fin.navercorp.com/payment-fe/order-web/issues/14289 */
    NONE: 'NONE', // 없음
} as const

export type DiscountPolicyType = Constant<typeof DiscountPolicy>

/** 복수구매적용유형 */
export const MultiPurchaseApply = {
    /** 수량무시 */
    IGNORE_QUANTITY: 'IGNORE_QUANTITY',
    /** 수량별 */
    QUANTITY: 'QUANTITY',
} as const

export type MultiPurchaseApplyType = Constant<typeof MultiPurchaseApply>

/**
 * 복수구매단위유형
 */
export const MultiPurchaseUnit = {
    /** 구매수량별 */
    PURCHASE_COUNT: 'PURCHASE_COUNT',
    /** 구매금액별 */
    PURCHASE_AMOUNT: 'PURCHASE_AMOUNT',
} as const

export type MultiPurchaseUnitType = Constant<typeof MultiPurchaseUnit>

/** 할인 제공자 */
export const DiscountProvider = {
    /** 판매자 */
    SELLER: 'SELLER',
    /** 관리자 */
    MANAGER: 'MANAGER',
} as const

export type DiscountProviderType = Constant<typeof DiscountProvider>

/** 즉시할인 쿠폰 유형 */
export const ImmediateDiscount = {
    /** 즉시할인 */
    IMMEDIATE: 'IMMEDIATE',
    /** 라이브할인 */
    LIVE: 'LIVE',
    /** 참여 프로모션 즉시할인 */
    PROMOTION: 'PROMOTION',
} as const

export type ImmediateDiscountType = Constant<typeof ImmediateDiscount>

export const ExclusiveCoupon = {
    NONE: 'NONE',
    MEMBERSHIP: 'MEMBERSHIP',
    LOUNGE_CONDITION: 'LOUNGE_CONDITION',
    RECENT_PURCHASE: 'RECENT_PURCHASE',
    NEW_PURCHASE: 'NEW_PURCHASE',
    REPEAT_PURCHASE: 'REPEAT_PURCHASE',
    DECREASE_GRADE: 'DECREASE_GRADE',
    SAME_GRADE: 'SAME_GRADE',
    TARGET_GRADE: 'TARGET_GRADE',
    EXPECT_JOIN_MEMBER: 'EXPECT_JOIN_MEMBER',
} as const

/** 전용 쿠폰 유형 */
export type ExclusiveCouponType = Constant<typeof ExclusiveCoupon>
